import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ReservationTab } from '../types';

interface IReservationTabsProps {
  activeTab: ReservationTab;
  onChange: (tab: ReservationTab) => void;
}

const TAB_CONFIG: { key: ReservationTab; labelKey: string }[] = [
  { key: 'checkin_today', labelKey: 'TaskManagemnt.tabCheckin' },
  { key: 'checkout_today', labelKey: 'TaskManagemnt.tabCheckout' },
  { key: 'upcoming', labelKey: 'TaskManagemnt.tabUpcoming' },
  { key: 'vacant', labelKey: 'TaskManagemnt.tabVacant' },
];

const ReservationTabs = ({ activeTab, onChange }: IReservationTabsProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'flex-start' }}>
      {TAB_CONFIG.map(({ key, labelKey }) => {
        const isActive = activeTab === key;
        return (
          <Box
            key={key}
            onClick={() => onChange(key)}
            sx={{
              cursor: 'pointer',
              width: '134px',
              height: '39px',
              px: '24px',
              py: '14px',
              borderRadius: '4px',
              backgroundColor: isActive ? '#5B3FFF' : '#FFFFFF',
              border: '1px solid #E5E3F8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: isActive ? '#4930CC' : '#F6F6F8',
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Tajawal, sans-serif',
                fontWeight: isActive ? 400 : 500,
                fontSize: '14px',
                color: isActive ? '#FFFFFF' : '#435363',
                whiteSpace: 'nowrap',
                userSelect: 'none',
              }}
            >
              {t(labelKey)}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default ReservationTabs;
